<template>
  <div class="introVideoWrapper" :class="playerActiveClass">
    <div class="videoWrapper">
      <vueVimeoPlayer ref="player" :video-id="videoID" :options="options"></vueVimeoPlayer>
    </div>
    <div class="controls">
      <div class="background"></div>
      <div class="soundContainer" @click="toggleMute">
        <svg width="51" height="54" viewBox="0 0 51 54" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" v-bind:svg-inline="''" v-if="muted" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><defs><filter x="-91.9%" y="-63%" width="283.7%" height="225.9%" filterUnits="objectBoundingBox" id="a"><feMorphology radius="1" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"/><feOffset in="shadowSpreadOuter1" result="shadowOffsetOuter1"/><feMorphology radius="3.5" in="SourceAlpha" result="shadowInner"/><feOffset in="shadowInner" result="shadowInner"/><feComposite in="shadowOffsetOuter1" in2="shadowInner" operator="out" result="shadowOffsetOuter1"/><feGaussianBlur stdDeviation="5" in="shadowOffsetOuter1" result="shadowBlurOuter1"/><feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" in="shadowBlurOuter1"/></filter><path d="M17.791.124a1.297 1.297 0 00-1.316.124L6.369 7.726H1.274C.57 7.726 0 8.284 0 8.972V21.56c0 .688.57 1.246 1.274 1.246h5.095l10.106 7.437c.386.283.902.329 1.334.117.431-.21.704-.642.704-1.114v-28c0-.48-.281-.915-.722-1.122z" id="b"/></defs><g fill="none" fill-rule="evenodd"><path d="M39.552 17.082c2.84 2.678 4.26 5.92 4.26 9.728s-1.373 7.185-4.12 10.133" stroke-opacity=".798" stroke="#FFF" stroke-width="2.5" stroke-linecap="round"/><path d="M43.296 13.636c3.703 3.565 5.555 7.957 5.555 13.174 0 5.218-1.852 9.728-5.555 13.532M36.246 20.643c1.763 1.571 2.645 3.627 2.645 6.167s-.882 4.715-2.645 6.524" stroke-opacity=".798" stroke="#FFF" stroke-width="2.5" stroke-linecap="round"/><g fill-rule="nonzero" transform="translate(11 12)"><use fill="#000" filter="url(#a)" xlink:href="#b"/><path stroke-opacity=".798" stroke="#FFF" stroke-width="2.5" d="M6.781 8.976l-5.531.006.024 12.574h5.505l10.484 7.68-.05-27.979-10.432 7.72z" stroke-linejoin="square"/></g></g></svg>
        <svg width="61" height="54" viewBox="0 0 61 54" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" v-bind:svg-inline="''" v-else="" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><defs><filter x="-450.3%" y="-96.6%" width="978.7%" height="293.2%" filterUnits="objectBoundingBox" id="a"><feMorphology radius="2.25" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"/><feOffset in="shadowSpreadOuter1" result="shadowOffsetOuter1"/><feMorphology radius="2.25" in="SourceAlpha" result="shadowInner"/><feOffset in="shadowInner" result="shadowInner"/><feComposite in="shadowOffsetOuter1" in2="shadowInner" operator="out" result="shadowOffsetOuter1"/><feGaussianBlur stdDeviation="5" in="shadowOffsetOuter1" result="shadowBlurOuter1"/><feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" in="shadowBlurOuter1"/></filter><filter x="-345.3%" y="-71.8%" width="773.8%" height="243.7%" filterUnits="objectBoundingBox" id="c"><feMorphology radius="2.25" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"/><feOffset in="shadowSpreadOuter1" result="shadowOffsetOuter1"/><feMorphology radius="2.25" in="SourceAlpha" result="shadowInner"/><feOffset in="shadowInner" result="shadowInner"/><feComposite in="shadowOffsetOuter1" in2="shadowInner" operator="out" result="shadowOffsetOuter1"/><feGaussianBlur stdDeviation="5" in="shadowOffsetOuter1" result="shadowBlurOuter1"/><feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" in="shadowBlurOuter1"/></filter><filter x="-725.3%" y="-151.1%" width="1515.3%" height="402.3%" filterUnits="objectBoundingBox" id="e"><feMorphology radius="2.25" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"/><feOffset in="shadowSpreadOuter1" result="shadowOffsetOuter1"/><feMorphology radius="2.25" in="SourceAlpha" result="shadowInner"/><feOffset in="shadowInner" result="shadowInner"/><feComposite in="shadowOffsetOuter1" in2="shadowInner" operator="out" result="shadowOffsetOuter1"/><feGaussianBlur stdDeviation="5" in="shadowOffsetOuter1" result="shadowBlurOuter1"/><feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" in="shadowBlurOuter1"/></filter><filter x="-91.9%" y="-63%" width="283.7%" height="225.9%" filterUnits="objectBoundingBox" id="g"><feMorphology radius="1" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"/><feOffset in="shadowSpreadOuter1" result="shadowOffsetOuter1"/><feMorphology radius="3.5" in="SourceAlpha" result="shadowInner"/><feOffset in="shadowInner" result="shadowInner"/><feComposite in="shadowOffsetOuter1" in2="shadowInner" operator="out" result="shadowOffsetOuter1"/><feGaussianBlur stdDeviation="5" in="shadowOffsetOuter1" result="shadowBlurOuter1"/><feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" in="shadowBlurOuter1"/></filter><path d="M3.306 3.446c2.84 2.678 4.26 5.92 4.26 9.728s-1.373 7.185-4.12 10.132" id="b"/><path d="M7.05 0c3.704 3.565 5.555 7.957 5.555 13.174 0 5.218-1.851 9.728-5.555 13.532" id="d"/><path d="M0 7.007c1.763 1.571 2.645 3.627 2.645 6.167S1.763 17.89 0 19.698" id="f"/><path d="M17.791.124a1.297 1.297 0 00-1.316.124L6.369 7.726H1.274C.57 7.726 0 8.284 0 8.972V21.56c0 .688.57 1.246 1.274 1.246h5.095l10.106 7.437c.386.283.902.329 1.334.117.431-.21.704-.642.704-1.114v-28c0-.48-.281-.915-.722-1.122z" id="h"/></defs><g fill="none" fill-rule="evenodd"><g stroke-linecap="round"><g transform="translate(36.246 13.636)"><use fill="#000" filter="url(#a)" xlink:href="#b"/><use stroke-opacity=".798" stroke="#FFF" stroke-width="2.5" xlink:href="#b"/></g><g transform="translate(36.246 13.636)"><use fill="#000" filter="url(#c)" xlink:href="#d"/><use stroke-opacity=".798" stroke="#FFF" stroke-width="2.5" xlink:href="#d"/></g><g transform="translate(36.246 13.636)"><use fill="#000" filter="url(#e)" xlink:href="#f"/><use stroke-opacity=".798" stroke="#FFF" stroke-width="2.5" xlink:href="#f"/></g></g><g fill-rule="nonzero" transform="translate(11 12)"><use fill="#000" filter="url(#g)" xlink:href="#h"/><path stroke-opacity=".798" stroke="#FFF" stroke-width="2.5" d="M6.781 8.976l-5.531.006.024 12.574h5.505l10.484 7.68-.05-27.979-10.432 7.72z" stroke-linejoin="square"/></g></g></svg>
      </div>
      <div class="skip" @click="skipVideo" v-ePitchTracking="'Skip Video'">Skip Video and Start Presentation</div>
    </div>
  </div>
</template>
<script>
import { vueVimeoPlayer } from "vue-vimeo-player";
import SvgImport from "@/components/global/SvgImport.vue";

export default {
  name: "IntroVideo",
  components: {
    vueVimeoPlayer,
    SvgImport
  },
  data() {
    return {
      videoID: "498060796",
      height: 500,
      options: {
        background: true
      },
      playerReady: false,
      playerActiveClass: "",
      muted: true
    };
  },
  methods: {
    skipVideo() {
      this.$refs.player.pause();
      this.playerActiveClass = "deactive";
      this.$router.push('landing')
      setTimeout(() => {
        this.$emit("skipVideo", true);
      }, 500);
    },
    setLoading(isLoading) {
      setTimeout(() => {
        this.$emit("setLoading", isLoading);
      }, 500);
    },
    toggleMute() {
      if (this.muted) {
        this.$refs.player.unmute();
      } else {
        this.$refs.player.mute();
      }
      this.playerActiveClass = "active";

      this.muted = !this.muted;
    }
  },
  mounted() {
    let that = this;
    this.$refs.player.player.on("loaded", function() {
      that.setLoading(false);
    });
    this.$refs.player.player.on("ended", function() {
      that.skipVideo();
      that.$router.push('landing')
    });
  }
};
</script> 

<style lang="scss" scoped>
.introVideoWrapper {
  z-index: 9999;
  position: relative;
  height: 100vh;
  max-height: 100vh;
  transition: 0.5s ease-in-out;
  overflow: hidden;
  background-color: #000;
  &.deactive {
    opacity: 0;
  }
  &:before {
    z-index: 1;
    position: absolute;
    content: '';
    bottom: 0;
    left: 0;
    width: 100vw;
    height: 31.0vh;
    background-image: linear-gradient(180deg, rgba(0,0,0,0.00) 0%, #000000 100%);
  }
}
.controls {
  z-index: 2;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  top: 85px;
  // bottom: 85px;
  right: 50%;
  transform: translateX(50%);
  padding: 8px 0;
}
.background {
  position: absolute;
  right: 0;
  height: 100%;
  width: 375px;
  background: #000000;
  opacity: 0.5;
  z-index: 1;
}
.skip {
  cursor: pointer;
  display: inline-block;
  // width: 166px;
  width: 375px;
  padding: 8px 0;
  font-size: 16px;
  font-family: 'ArtegraSans-Bold';
  line-height: 24px;
  letter-spacing: 1px;
  text-align: center;
  text-transform: uppercase;
  text-decoration: none;
  color: #fff;
  z-index: 2;
  &:before, &:after {
    position: absolute;
    content: '';
    // width: 166px;
    width: 375px;
    height: 1px;
    background: rgba(255,255,255,0.80);
    box-shadow: 0 0 8px 2px #FFFFFF;
  }
  &:before {
    top: 0;
    right: 0;
  }
  &:after {
    bottom: 0;
    right: 0;
  }
}
.soundContainer {
  margin-right: 16px;
  height: 40px;
  width: 40px;
  padding: 8.8px;
  // border-radius: 50%;
  // background: rgba(255, 255, 255, 0.50);
  transition: all 0.5s ease-in-out;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
  }
  svg {
    vertical-align: inherit;
    outline: none;
    position: relative;
    bottom: 16px;
    right: 25px;
  }
  > div {
    top: 50%;
    transform: translateY(-10%);
  }
}
</style>
<style lang="scss">
.videoWrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  iframe {
    width: 100vw;
    height: 56.25vw;
    min-height: 100vh;
    min-width: 177.77vh;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>